module.exports = __webpack_public_path__ + "static/media/new-logo-w.6549c505.png";